<template>
	<div class="new-list">
		<div class="new-body" v-for="(item,index)  in list_news" :key="index">
			<div class="new-title" @click="look_news(item.out_a)">
				{{item.s_title}}
			</div>
			<div class="new-desc" @click="look_news(item.out_a)">
				{{item.s_desc}}
			</div>
			<div class="new-date">
				{{item.sys_date}}
			</div>
		</div>

	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Sel_Mobile
	} from '@/utils/loadhttpdata.js';

	export default {
		data() {
			return {
				element_loading: false,

				nowpage: 1,
				allpage: 1,
				page_length: 10,


				list_news: [],


			};
		},
		created: function() {
			console.log('新闻加载开始');
			this.list_news = [];

			this.init_data(); //加载首页滚动图片
		},
		methods: {
			look_news: function(url) {

				window.open(url);
			},
			init_data: function() {
				this.$post(
					api.http_method, Sel_Mobile('home_news_set', this.nowpage, this.page_length)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.length > 0 && res[0][0].flag == '1') {
						this.allpage = res[0][0].all_page;

						if (this.nowpage >= this.allpage) {
							this.mystatus = "noMore";
						}

						if (res[0][0].all_count > 0) {
							let arr = [];
							arr = res[1];
							// console.log(arr);
							for (let i = 0; i < arr.length; i++) {
								this.list_news.push(arr[i]);
							}

						}

					} else {
						this.$message({
							message: '没有查询到数据!',
							type: 'success'
						});
					}


				});

			},
			load_more: function() {

				// 判断是否有数据
				if (this.nowpage >= this.allpage) {
					this.$message({
						message: '没有更多数据!',
						type: 'success'
					});
					return;
				} else {
					this.mystatus = "loading";

					uni.pageScrollTo({
						duration: 300,
						selector: '#page_down'
					});
				}

				this.nowpage++;
				// console.log('加载第=' + this.nowpage + ' 页');
				this.load_data(); // 获取数据
			},
		}
	};
</script>

<style scoped="scoped">
	.new-list {
		display: inline-flex;
		flex-direction: column;
		max-width: 960px;
		margin: 20px;

	}

	.new-body {
		display: flex;
		flex-direction: column;
	}

	.new-title {
		display: flex;
		font-size: 20px;
		font-weight: bold;

		cursor: pointer;
	}

	.new-desc {
		display: flex;
		font-size: 18px;
		margin-top: 6px;
		margin-bottom: 6px;
		/* 空两格 */
		text-indent: 2em;
		text-align: left;

		cursor: pointer;
	}

	.new-date {
		display: flex;
		font-size: 16px;
		font-weight: bold;
		justify-content: flex-end;
		color: #868686;
	}
</style>
